import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import AuthLayout from './layout'
import ForgotPasswordForm from '../../components/form/auth/forgot.password'
import {useTranslation} from 'react-i18next';
import {EAlert} from "../../enums";
import {AlertBig, AlertBigInfoText} from "../../components/alert/AlertBig";
import {AuthInfoText} from "./signin";

const ForgotPassword = () => {
    const {t} = useTranslation();
    const [isComplete, setComplete] = useState(false)

    return (
        <AuthLayout imgUrl="/pages/auth/illustration.svg"
                    title={t('auth.forgot_password.title')}
                    description={t('auth.forgot_password.description')}>
            {!isComplete ?
                <ForgotPasswordForm onComplete={() => setComplete(true)}/>
                : (
                    <div className="w-full mb-6">
                        <AlertBig
                          type={EAlert.success}
                          title={t('auth.forgot_password.completed')}
                        >
                          <AlertBigInfoText>{t('auth.forgot_password.wait_email')}</AlertBigInfoText>
                        </AlertBig>
                    </div>
                )}


            <div className="flex flex-row justify-center w-full mt-6 mb-2">
                <AuthInfoText className="mr-1">{t('auth.newuser')}</AuthInfoText>
                <AuthInfoText>
                  <Link className="link" to="/auth/signup">
                    {t('auth.create_account')}
                  </Link>
                </AuthInfoText>
            </div>
            <div className="flex flex-row justify-center w-full">
                <AuthInfoText>
                  <Link className="link" to="/auth/signin">
                    {t('auth.forgot_password.goback_to_login')}
                  </Link>
                </AuthInfoText>
            </div>
        </AuthLayout>
    )
}

export default ForgotPassword
